import { useReportRoutingLogById } from "../../../hooks/useReportRoutingLogs"
import { formatISODate } from "../../../utils/datetime"
import Loader from "../../../components/Loader"
import Modal from "../../../components/Modal"
import { memo } from "react"
import ReactJson from "react-json-view"

const ReportRoutingModal = memo(
  ({ isOpen, onClose, reportRoutingId, isNormalReport }) => {
    const { data, isLoading } = useReportRoutingLogById(reportRoutingId)

    return (
      <Modal className="max-w-[70%] h-[70vh] overflow-y-hidden" isOpen={isOpen}>
        <div className="p-2">
          {isLoading ? (
            <div className="flex justify-center gap-3 items-center py-2">
              <Loader />
              Loading...
            </div>
          ) : data ? (
            <div className="grid grid-cols-1 gap-3">
              <div className="flex justify-between">
                <div className="flex gap-10">
                  <p>
                    <strong>Accession No: </strong> {data?.AccessionNo}
                  </p>
                  <p>
                    <strong>Patient MRN: </strong> {data?.PatientMRN}
                  </p>
                  <p>
                    <strong>Created At: </strong>{" "}
                    {formatISODate(data?.createdAt)}
                  </p>
                  <p>
                    <strong>Log Type: </strong> {data?.ReRouteReason}
                  </p>
                </div>
                <button
                  className="text-gray-600 hover:text-gray-900 text-3xl ml-auto"
                  onClick={onClose}
                >
                  ×
                </button>
              </div>
              <div className="overflow-y-auto max-h-[58vh]">
                <div>
                  <h2 className="text-xl font-bold mb-1">
                    Extracted Report Text
                  </h2>
                  <p className="text-gray-900 rounded-md bg-gray-100 p-4 max-h-[40vh] overflow-y-auto">
                    {data?.logDetails?.ExtractedReportText || "N/A"}
                  </p>
                </div>
                {isNormalReport && (
                  <div>
                    <h2 className="text-xl font-bold mb-1">AI Response</h2>
                    <p className="text-gray-900 whitespace-pre-wrap break-words">
                      {data?.logDetails?.AIResponse ? (
                        <div className="rounded-md bg-gray-100 p-4">
                          {(() => {
                            try {
                              return (
                                <ReactJson
                                  displayDataTypes={false}
                                  displayObjectSize={false}
                                  enableClipboard={false}
                                  name={null}
                                  src={JSON.parse(data?.logDetails?.AIResponse)}
                                />
                              )
                            } catch (error) {
                              return <span>{data?.AIResponse}</span>
                            }
                          })()}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                )}
                <div className="mt-2">
                  <h2 className="text-xl font-bold">Re-Routing Reason</h2>
                  <div className="rounded-md bg-gray-100 p-4 mt-2">
                    <p className="text-gray-900 mb-2">
                      <strong>
                        {data?.ReRouteReason?.split("_").join(" ")}
                      </strong>
                    </p>
                    {isNormalReport ? (
                      <p className="text-gray-900">{data?.Description}</p>
                    ) : (
                      <div className="flex flex-wrap gap-2">
                        {data?.Description?.split(", ").map(
                          (keyword, index) => (
                            <span
                              key={index}
                              className="inline-block px-3 py-1 text-sm font-medium bg-blue-100 text-blue-800 rounded-full border"
                            >
                              {keyword.trim()}
                            </span>
                          )
                        ) || <span className="text-gray-500">N/A</span>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col">
              <div className="flex justify-between">
                <div />
                <button
                  className="text-gray-600 hover:text-gray-900 text-3xl ml-auto"
                  onClick={onClose}
                >
                  ×
                </button>
              </div>
              <h2 className="text-xl font-bold mb-1 text-center">
                No log found
              </h2>
            </div>
          )}
        </div>
      </Modal>
    )
  }
)

ReportRoutingModal.displayName = "ReportRoutingModal"

export default ReportRoutingModal
